import preparedReducer from './reducer';
import {
  requestBIIncidentReportsByType,
  requestBIIncidentReportsGroupedByDate,
  requestBIIncidentReportsGroupedByDateAndType,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'biIncidentReports';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestBIIncidentReportsByType,
  requestBIIncidentReportsGroupedByDateAndType,
  requestBIIncidentReportsGroupedByDate,
};
